import React from 'react';
import { Helmet } from 'react-helmet-async';
import { FiBookOpen, FiShield, FiAlertOctagon, FiActivity } from 'react-icons/fi';

const Resources = () => {
  return (
    <>
      <Helmet>
        <title>Educational Resources | Recall Moringa</title>
      </Helmet>

      <div className="bg-white py-12">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h1 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Safety Resource Hub</h1>
            <p className="text-lg text-gray-600">
              Evidence-based guides to help you understand moringa safety, identify quality products, and recognize health risks.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            
            {/* Guide 1 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:shadow-lg transition-all group cursor-pointer">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-6 text-primary group-hover:scale-110 transition-transform">
                <FiShield size={24} />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors">
                How to Identify Safe Supplements
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Learn the 5 red flags on supplement labels and how to verify third-party testing certificates (COA) before you buy.
              </p>
              <span className="text-primary font-bold text-sm underline">Read Guide</span>
            </div>

            {/* Guide 2 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:shadow-lg transition-all group cursor-pointer">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-6 text-alert group-hover:scale-110 transition-transform">
                <FiAlertOctagon size={24} />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors">
                Symptoms of Contamination
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Early warning signs of Salmonella and heavy metal toxicity. When to stop taking supplements and see a doctor.
              </p>
              <span className="text-primary font-bold text-sm underline">Read Guide</span>
            </div>

            {/* Guide 3 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:shadow-lg transition-all group cursor-pointer">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-6 text-blue-500 group-hover:scale-110 transition-transform">
                <FiBookOpen size={24} />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors">
                Understanding FDA Regulations
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Why supplements aren't FDA approved like drugs, and what the "DSHEA" act means for your safety as a consumer.
              </p>
              <span className="text-primary font-bold text-sm underline">Read Guide</span>
            </div>

            {/* Guide 4 */}
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 hover:shadow-lg transition-all group cursor-pointer">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm mb-6 text-green-500 group-hover:scale-110 transition-transform">
                <FiActivity size={24} />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors">
                Safe Dosage Guidelines
              </h2>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Recommended daily limits for powder and capsules based on current clinical research and toxicity studies.
              </p>
              <span className="text-primary font-bold text-sm underline">Read Guide</span>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Resources;